import React from "react";
import propTypes from "prop-types";
import styled from "styled-components";

const getChildrenByDisplayName = (children, displayName) => 
    React.Children.map(children, (child) => 
        child.type.displayName === displayName ? child : null
    );

const Card = ({children, ...rest}) => {
    const header = getChildrenByDisplayName(children, 'Header');
    const media = getChildrenByDisplayName(children, 'Media')
    const body = getChildrenByDisplayName(children, 'Body');
    const footer = getChildrenByDisplayName(children, 'Footer')
    const CardWrapper= styled.div`
    .usa-card__container, .usa-card__heading, .usa-card__footer{
        border-radius: ${rest.borderRadius};
    }
    .usa-card__header > :first-child, .usa-card__body > :first-child{
        padding-top: ${rest.roundImage ? "20px": "0"}
    }
  `;
    
    let classList = `usa-card ${rest.headerFirst?"usa-card--header-first": ""}${rest.grid} ${rest.tabIndex===-1 ? "no-focus": ""}`;

    return (
    <div className={classList} tabIndex={rest.tabIndex}> 
        <CardWrapper className={`usa-card__container ${rest.background} ${rest.size}`} onClick={rest.onClick} onMouseOver={rest.addHoverAnimation} onMouseOut={rest.removeHoverAnimation}>
           {header}
           {media}
           {body}
           {footer}
        </CardWrapper>
    </div>
    )
}
const Header = ({children}) => <div className='usa-card__header'>{children}</div>;
Header.displayName = "Header";
Card.Header = Header;

const Media = ({children, mediaClass}) => <div className={`usa-card__media ${mediaClass}`}>{children}</div>;
Media.displayName = "Media";
Card.Media = Media;

const Body = ({children, cardBody}) => <div className={`usa-card__body ${cardBody}`}>{children}</div>;
Body.displayName = "Body";
Card.Body = Body;

const Footer = ({children, cardFooter}) => <div className={`usa-card__footer ${cardFooter}`}>{children}</div>;
Footer.displayName = "Footer";
Card.Footer = Footer;

export default Card;

Card.propTypes = { 
    headerFirst:propTypes.oneOf([true, false]),
    grid: propTypes.oneOfType([propTypes.string]),
    background: propTypes.oneOfType([propTypes.string]),
    size: propTypes.oneOfType([propTypes.string]),
    borderRadius: propTypes.oneOfType([propTypes.string]),
    roundImage: propTypes.oneOf([true, false]),
    tabIndex: propTypes.oneOf([-1, 0]),

}
Card.defaultProps = {
    headerFirst: false,
    grid: "tablet:grid-col-4",
    background: "",
    size: "",
    borderRadius: "0",
    roundImage: false,
    tabIndex: -1
}
Body.propTypes = { 
    cardBody: propTypes.oneOfType([propTypes.string])
}
Body.defaultProps = {
    cardBody: ""
}
Footer.propTypes = { 
    cardFooter: propTypes.oneOfType([propTypes.string])
}
Footer.defaultProps = {
    cardFooter: ""
}
Media.propTypes = { 
    mediaClass: propTypes.oneOfType([propTypes.string])
}
Media.defaultProps = {
    mediaClass: ""
}
